import React, { useState, useEffect, useLayoutEffect } from "react";

import { trackPromise } from "react-promise-tracker";

import {
  listarUsuariosQuePossuiPermissoesPaginados,
  permissoesPaginados,
  usuariosPaginados,
} from "../../services/http/usuariosService";

import { Avatar, Badge, Input, List } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";
import { SearchOutlined } from "@ant-design/icons";

import { Modal, message } from "antd";

import "./styles.scss";
import { BorderBottom, CloseOutlined } from "@mui/icons-material";
import { Pagination, PaginationItem } from "@mui/material";
import lang from "../../assets/idioma/idiomas";

const ModalListaUsuarios = ({
  closeModal,
  openModal,
  setUsuarios,
  usuarios,
}) => {
  const [listagemUsuarios, setListagemUsuarios] = useState([]);
  const [listagemUsuariosSelecionados, setListagemUsuariosSelecionados] =
    useState([]);

  const [quantidadeUsuarios, setQuantidadeUsuarios] = useState([]);
  const [aba, setAba] = useState(1);
  const [page, setPage] = useState(1);
  const [contadorAtribuicao, setContadorAtribuicao] = useState(0);
  const [inputPagination, setInputPagination] = useState(1);
  const [inputPaginationPerm, setInputPaginationPerm] = useState(1);

  const changeInputPagination = (value) => {
    setInputPagination(value === "" ? "" : Number(value));
    setPage(value === "" ? 1 : Number(value));
  };

  useEffect(() => {
    setInputPagination(page);
  }, [page]);

  const handleChange = (e, p) => {
    setPage(p);
  };
  const renderPaginationButtons = () => {
    const pageCount = Math.ceil((listagemUsuarios?.totalCount || 0) / 10);
    const paginationButtons = [];

    for (let i = 1; i <= pageCount; i++) {
      paginationButtons.push(
        <PaginationItem
          key={i}
          className={page === i ? "selected-pageNoti" : ""}
          onClick={(event) => handleChange(event, i)}
        >
          {i}
        </PaginationItem>
      );
    }

    return paginationButtons;
  };
  useEffect(() => {
    obterUsuarioPaginados(page);
  }, [page]);

  const showIniciais = (nome) => {
    if (!nome) return "??";
    let nomecompleto = nome.replace(".", " ");
    var iniciais = nomecompleto.match(/\b(\w)/gi);
    if (!iniciais) return "??";
    var sobrenomes = iniciais.splice(0, iniciais.length).join("").toUpperCase();
    return sobrenomes;
  };

  function verificaUsuarios() {
    usuarios.map((e) => (e.checked = true));
    setListagemUsuariosSelecionados(usuarios);
  }

  const obterUsuarioPaginados = (page) => {
    setPage(page);
    usuariosPaginados(page, 10)
      .then((res) => {
        console.log("Resposta usuariosPaginados:", res);
        if (!res.fail && res.data) {
          // A API retorna os usuários em res.data.data
          const usuariosLista = res.data.data || res.data.lista;

          if (usuariosLista && Array.isArray(usuariosLista)) {
            const novaLista = usuariosLista.map((e) => {
              const selecionado = listagemUsuariosSelecionados.find(
                (ele) => e.id === ele.id
              );

              if (selecionado) {
                return selecionado;
              } else {
                return e;
              }
            });

            setListagemUsuarios({
              lista: novaLista,
              totalCount: res.data.totalCount || 0
            });
          } else {
            console.error("Lista de usuários não encontrada na resposta:", res.data);
            setListagemUsuarios({ lista: [], totalCount: 0 });
          }
        } else {
          console.error("Falha na resposta ou dados ausentes:", res);
          setListagemUsuarios({ lista: [], totalCount: 0 });
        }
      })

      .catch((error) => {
        console.error("Erro ao obter usuários paginados:", error);
        setListagemUsuarios({ lista: [], totalCount: 0 });
      });
  };

  const adicionarOuRemoverUsuario = (item) => {
    if (item.checked) {
      listagemUsuariosSelecionados.map((e) => {
        if (e.id == item.id) {
          e.checked = false;
          setListagemUsuariosSelecionados((prev) =>
            prev.find((usuario) => usuario.id === e.id)
              ? prev.filter((usuario) => usuario.id !== e.id)
              : [...prev, e]
          );
        }
      });
    } else {
      listagemUsuarios.lista.map((e) => {
        if (e.id == item.id) {
          e.checked = true;
          setListagemUsuariosSelecionados((prev) => [...prev, e]);
        }
      });
    }
  };

  const selecionarTodosUsuariosUmaVez = () => {
    trackPromise(
      usuariosPaginados(1, 100000)
        .then((res) => {
          if (!res.fail && res.data) {
            const usuariosLista = res.data.data || res.data.lista || [];
            setQuantidadeUsuarios(usuariosLista.length);
          }
        })

        .catch((error) => {
          console.error(error);
        })
    );
  };

  const fnTodosCheckbox = () => {
    if (
      quantidadeUsuarios !== listagemUsuariosSelecionados.length ||
      listagemUsuariosSelecionados == 0
    ) {
      trackPromise(
        usuariosPaginados(1, 100000)
          .then((res) => {
            if (!res.fail && res.data) {
              const usuariosLista = res.data.data || res.data.lista || [];
              usuariosLista.map((e) => (e.checked = true));
              setListagemUsuariosSelecionados(usuariosLista);
            }
          })

          .catch((error) => {
            console.error(error);
          })
      );
    } else {
      setListagemUsuariosSelecionados([]);
    }
  };

  const pesquisarPorUsuario = (event) => {
    const value = event.target.value;
    const delayDebounceFn = setTimeout(() => {
      trackPromise(
        usuariosPaginados(1, 10, value)
          .then((res) => {
            if (!res.fail && res.data) {
              if (value != "") {
                const usuariosLista = res.data.data || res.data.lista || [];
                setListagemUsuarios({
                  lista: usuariosLista,
                  totalCount: res.data.totalCount || 0
                });
              } else {
                obterUsuarioPaginados(page);
              }
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    }, 2000);

    return () => clearTimeout(delayDebounceFn);
  };

  useEffect(() => {
    obterUsuarioPaginados(page);
  }, [listagemUsuariosSelecionados]);

  useEffect(() => {
    verificaUsuarios();
    obterUsuarioPaginados(page);
  }, []);

  ////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////

  const [listagemPermissoes, setListagemPermissoes] = useState([]);
  const [listagemPermissoesSelecionadas, setListagemPermissoesSelecionadas] =
    useState([]);
  const [usuariosComPermissao, setUsuariosComPermissao] = useState(false);
  const [quantidadePermissoes, setQuantidadePermissoes] = useState([]);

  const obterPermissoesPaginados = (page) => {
    setPage(page);
    permissoesPaginados(page, 10)
      .then((res) => {
        if (!res.fail) {
          const novaLista = res.data.items.map((e) => {
            const selecionado = listagemPermissoesSelecionadas.find(
              (ele) => e.id === ele.id
            );

            if (selecionado) {
              return selecionado;
            } else {
              return e;
            }
          });

          res.data.items = novaLista;
          setListagemPermissoes(res.data);
        }
      })

      .catch((error) => {
        console.error(error);
      });
  };

  const adicionarOuRemoverPermissao = (item) => {
    if (item.checked) {
      listagemPermissoesSelecionadas.map((e) => {
        if (e.id == item.id) {
          e.checked = false;
          setListagemPermissoesSelecionadas((prev) =>
            prev.find((permissao) => permissao.id === e.id)
              ? prev.filter((permissao) => permissao.id !== e.id)
              : [...prev, e]
          );
        }
      });
    } else {
      listagemPermissoes.items.map((e) => {
        if (e.id == item.id) {
          e.checked = true;
          setListagemPermissoesSelecionadas((prev) => [...prev, e]);
        }
      });
    }
  };
  const fnListarUsuariosQuePossuiPermissoes = (id) => {
    trackPromise(
      listarUsuariosQuePossuiPermissoesPaginados(id)
        .then((res) => {
          if (!res.fail) {
            setUsuariosComPermissao((prev) => [...prev, ...res.data.items]);
            setContadorAtribuicao(contadorAtribuicao + 1);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const fnTodosCheckboxPermissoes = () => {
    if (
      quantidadePermissoes !== listagemPermissoesSelecionadas.length ||
      listagemPermissoesSelecionadas == 0
    ) {
      trackPromise(
        permissoesPaginados(1, 100000)
          .then((res) => {
            if (!res.fail) {
              res.data.items.map((e) => (e.checked = true));
              setListagemPermissoesSelecionadas(res.data.items);
            }
          })

          .catch((error) => {
            console.error(error);
          })
      );
    } else {
      setListagemPermissoesSelecionadas([]);
    }
  };
  const selecionarTodasPermissoes = () => {
    trackPromise(
      permissoesPaginados(1, 100000)
        .then((res) => {
          if (!res.fail) {
            setQuantidadePermissoes(res.data.items.length);
          }
        })

        .catch((error) => {
          console.error(error);
        })
    );
  };
  const pesquisarPorPermissoes = (event) => {
    const value = event.target.value;
    const delayDebounceFn = setTimeout(() => {
      trackPromise(
        permissoesPaginados(1, 10, value)
          .then((res) => {
            if (!res.fail) {
              if (!res.fail) {
                if (value != "") {
                  setListagemPermissoes({ items: res.data.items });
                } else {
                  obterPermissoesPaginados(page);
                }
              }
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    }, 2000);

    return () => clearTimeout(delayDebounceFn);
  };

  function enviaUsuario() {
    const ids = {};
    const removeRepetidos = usuariosComPermissao
      .concat(listagemUsuariosSelecionados)
      .reduce((acc, item) => {
        if (!ids[item.id]) {
          ids[item.id] = true;
          acc.push(item);
        }
        return acc;
      }, []);
    setUsuarios(removeRepetidos);
    closeModal();
  }

  ////////////permissoes/////////////
  ////////////permissoes/////////////
  ////////////permissoes/////////////
  ////////////permissoes/////////////

  useEffect(() => {
    obterPermissoesPaginados(page);
  }, [listagemPermissoesSelecionadas]);

  useEffect(() => {
    obterPermissoesPaginados(page);
    selecionarTodasPermissoes();
    selecionarTodosUsuariosUmaVez();
  }, []);

  useEffect(() => {
    setUsuariosComPermissao([]);
    for (var x = 1; x <= listagemPermissoesSelecionadas.length; x++) {
      fnListarUsuariosQuePossuiPermissoes(
        listagemPermissoesSelecionadas[x - 1].id
      );
    }
  }, [listagemPermissoesSelecionadas]);

  const changeInputPaginationPerm = (value) => {
    setInputPaginationPerm(value === "" ? "" : Number(value));
    setPage(value === "" ? 1 : Number(value));
  };

  useEffect(() => {
    setInputPaginationPerm(page);
  }, [page]);

  const handleChangePerm = (e, p) => {
    setPage(p);
  };
  const renderPaginationButtonsPerm = () => {
    const pageCount = Math.ceil((listagemPermissoes?.totalCount || 0) / 10);
    const paginationButtons = [];

    for (let i = 1; i <= pageCount; i++) {
      paginationButtons.push(
        <PaginationItem
          key={i}
          className={page === i ? "selected-pageNoti" : ""}
          onClick={(event) => handleChange(event, i)}
        >
          {i}
        </PaginationItem>
      );
    }

    return paginationButtons;
  };
  useEffect(() => {
    obterPermissoesPaginados(page);
  }, [page]);
  return (
    <Modal
      title={
        <span className="modal-title-usuPerm ">{lang.Adicionar_usuarios}</span>
      }
      visible={openModal}
      className="modal-novo"
      closable={false}
      destroyOnClose={true}
      footer={[
        <div className="buttons-finalizar-upload">
          <button
            onClick={closeModal}
            className="button-publicar-mim"
            style={{ borderColor: "#828282", color: "#828282" }}
          >
            {lang.Cancelar}
          </button>
          <button
            className="button-publicar-todos"
            onClick={() => enviaUsuario()}
          >
            {lang.Ok}
          </button>
        </div>,
      ]}
    >
      <CloseOutlined onClick={closeModal} className="custom-close-icon" />
      {aba == 1 && (
        <div className="espacoInternoUsuarios">
          <div className="row card-list-UserPerm  fundoModal">
            {listagemUsuariosSelecionados.map((item, index) => {
              const nomeUsuario = item.userName || item.login || item.nome;
              return (
                <div key={index} className="col-md-2 col-sm-2 col-xl-2 mb-2">
                  <span className="avatar-item">
                    {item.checked && (
                      <Badge
                        size="small"
                        style={{ color: "#fff" }}
                        className="d-flex justify-content-center align-items-center flex-column"
                        onClick={() => adicionarOuRemoverUsuario(item)}
                        offset={[2, 5]}
                        count={
                          <CloseCircleFilled
                            style={{ color: "#000", cursor: "pointer" }}
                          />
                        }
                      >
                        <Avatar
                          style={{ background: "#828282", color: "#FFFFFF" }}
                        >
                          {showIniciais(nomeUsuario)}
                        </Avatar>
                        <div className="nomeAvatar">
                          <b>
                            {nomeUsuario && nomeUsuario.length <= 8
                              ? nomeUsuario
                              : nomeUsuario ? nomeUsuario.slice(0, 8) + "..." : "N/A"}
                          </b>
                        </div>
                      </Badge>
                    )}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {aba == 2 && (
        <div className="espacoInternoUsuarios">
          <div className="row card-list-UserPerm  fundoModal">
            {listagemPermissoesSelecionadas?.map((item, index) => (
              <div key={index} className="col-md-2 col-sm-2 col-xl-2 mb-2">
                <span className="avatar-item">
                  {item.checked && (
                    <Badge
                      size="small"
                      style={{ color: "#fff" }}
                      className="d-flex justify-content-center align-items-center flex-column"
                      onClick={() => adicionarOuRemoverPermissao(item)}
                      offset={[2, 5]}
                      count={
                        <CloseCircleFilled
                          style={{ color: "#000", cursor: "pointer" }}
                        />
                      }
                    >
                      <Avatar
                        style={{
                          background: "#828282",
                          color: "#FFFFFF",
                          marginBottom: 5,
                        }}
                      >
                        <span style={{ color: "#fff" }}>
                          {showIniciais(item.permissao)}
                        </span>
                      </Avatar>
                      <div className="nomeAvatar">
                        <b>
                          {item.permissao.length <= 8
                            ? item.permissao
                            : item.permissao.slice(0, 8) + "..."}
                        </b>
                      </div>
                    </Badge>
                  )}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="fundoModal mt-5">
        <div className="row espacoInternoUsuarios">
          <div
            style={{ padding: "0px" }}
            className="col-md-6 col-sm-6 col-xl-6 mb-3 mt-3"
          >
            <span
              onClick={() => {
                setAba(1);
              }}
              style={{
                color: "blue",
                cursor: "pointer",
                borderBottom: aba == 1 ? "blue 4px solid" : "none",
                fontWeight: aba == 1 ? "" : "normal",
                fontSize: "15px",
              }}
            >
              {lang.Contatos}
            </span>
            <span
              onClick={() => {
                setAba(2);
              }}
              style={{
                color: "blue",
                cursor: "pointer",
                marginLeft: 40,
                borderBottom: aba == 2 ? "blue 4px solid" : "none",
                fontWeight: aba == 2 ? "" : "normal",
                fontSize: "15px",
              }}
            >
              {lang.Permissoes}
            </span>
          </div>

          <div className="col-md-6 col-sm-6 col-xl-6 mt-3 p-0">
            {aba == 1 && (
              <>
                <Input
                  size="small"
                  placeholder={lang.Pesquisar}
                  className="pesquisar-usuario"
                  onChange={(event) => pesquisarPorUsuario(event)}
                  prefix={
                    <SearchOutlined
                      style={{ color: "#828282", fontSize: "18px" }}
                    />
                  }
                />
              </>
            )}

            {aba == 2 && (
              <Input
                size="small"
                placeholder="Pesquisar"
                className="pesquisar-usuario"
                onChange={(event) => pesquisarPorPermissoes(event)}
                prefix={
                  <SearchOutlined
                    style={{ color: "#828282", fontSize: "18px" }}
                  />
                }
              />
            )}
          </div>
        </div>

        {aba == 1 && (
          <div className="espacoInternoUsuarios">
            <div className="d-flex align-items-center justify-content-end w-100 mt-2">
              <spa className="mr-2">{lang.Selecionar_todos}:</spa>
              <input
                style={{ cursor: "pointer" }}
                checked={
                  quantidadeUsuarios == listagemUsuariosSelecionados.length &&
                  listagemUsuariosSelecionados.length != 0
                }
                onChange={() => {
                  fnTodosCheckbox();
                }}
                type="checkbox"
              />
            </div>
            <List
              itemLayout="horizontal"
              dataSource={listagemUsuarios?.lista || []}
              renderItem={(item, index) => {
                const nomeUsuario = item.userName || item.login || item.nome;
                return (
                  <List.Item>
                    <List.Item.Meta
                      key={item.id}
                      avatar={
                        <Avatar
                          style={{
                            background: index % 2 === 0 ? "#828282" : "#33a7ef ",
                            color: "#FFFFFF",
                          }}
                        >
                          {showIniciais(nomeUsuario)}
                        </Avatar>
                      }
                      title={nomeUsuario}
                    />

                    <input
                      style={{ cursor: "pointer" }}
                      checked={item.checked}
                      onChange={() => adicionarOuRemoverUsuario(item)}
                      type="checkbox"
                    />
                  </List.Item>
                );
              }}
            />
            <div className="row">
              <div
                className="col-12 p-0 mt20"
                style={{ display: "flex", justifyContent: "end" }}
              >
                <Pagination
                  count={Math.ceil((listagemUsuarios?.totalCount || 0) / 10)}
                  defaultPage={1}
                  variant="outlined"
                  shape="rounded"
                  onChange={handleChange}
                  color="secondary"
                  page={page}
                >
                  {renderPaginationButtons()}
                </Pagination>
                <div className="div-iput-page">
                  <input
                    className="input-pagination"
                    onChange={(e) => changeInputPagination(e.target.value)}
                    type="number"
                    value={inputPagination}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {aba == 2 && (
          <div className="espacoInternoUsuarios">
            <div className="d-flex align-items-center justify-content-end w-100 mt-2 ">
              <spa className="mr-2">Selecionar todos:</spa>
              <input
                style={{ cursor: "pointer" }}
                checked={
                  quantidadePermissoes ==
                    listagemPermissoesSelecionadas.length &&
                  listagemPermissoesSelecionadas.length != 0
                }
                onChange={() => {
                  fnTodosCheckboxPermissoes();
                }}
                type="checkbox"
              />
            </div>
            <List
              itemLayout="horizontal"
              dataSource={listagemPermissoes?.items || []}
              renderItem={(item, index) => (
                <List.Item>
                  <List.Item.Meta
                    key={item.id}
                    avatar={
                      <Avatar
                        style={{
                          background: index % 2 === 0 ? "#828282" : "#33a7ef ",
                          color: "#FFFFFF",
                        }}
                      >
                        {showIniciais(item.permissao)}
                      </Avatar>
                    }
                    title={item.permissao}
                  />
                  <input
                    style={{ cursor: "pointer" }}
                    checked={item.checked}
                    onChange={() => adicionarOuRemoverPermissao(item)}
                    type="checkbox"
                  />
                </List.Item>
              )}
            />
            <div className="row">
              <div
                className="col-12 p-0 mt20"
                style={{ display: "flex", justifyContent: "end" }}
              >
                <Pagination
                  count={Math.ceil((listagemPermissoes?.totalCount || 0) / 10)}
                  defaultPage={1}
                  variant="outlined"
                  shape="rounded"
                  onChange={handleChangePerm}
                  color="secondary"
                  page={page}
                >
                  {renderPaginationButtons()}
                </Pagination>
                <div className="div-iput-page">
                  <input
                    className="input-pagination"
                    onChange={(e) => changeInputPaginationPerm(e.target.value)}
                    type="number"
                    value={inputPaginationPerm}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalListaUsuarios;
